export default "__VITE_ASSET__Btd43OdU__"